import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { withTheme } from '@emotion/react'
import { withRouter } from "react-router";
import styled from '@emotion/styled';
import Navigation from '../../components/Navigation';
import Footer from '../../components/Footer';
import SearchForm from '../../components/SearchForm/';
import InfiniteListWithVerticalScroll from '../../components/InfiniteScroll/InfiniteScroll';

import {
  SEOData
} from './data'

const ContentContainer = styled.div`
  align-items: center;
  display: flex;
  flex-basis: 100%;
  flex-direction: column;
  justify-content: center;
  margin-top: ${props => props.marginTop || '54px'};
  padding: ${props => !!props.paddingTop ? `${props.paddingTop} ${props.theme.margins.std} ${props.theme.margins.std}` : props.theme.margins.std};
`;

const Wrapper = styled.span`
  min-height: calc(100vh - 297px);
  display: block;
`;

function SearchResults(props) {
  const searchParams = (props.location && props.location.state && props.location.state.searchValues) || {};
  const { title, description, keywords } = SEOData;

  useEffect(() => {

  }, [searchParams]);
  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
      </Helmet>
      <Navigation />
      <Wrapper>
        <ContentContainer>
          <SearchForm simplified={true} searchValues={searchParams} />
        </ContentContainer>
        <ContentContainer marginTop="0px">
          <InfiniteListWithVerticalScroll />
        </ContentContainer>
      </Wrapper>
      <Footer />
    </>
  );
}

export default withRouter(withTheme(SearchResults));